import React, {Component} from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import * as Yup from "yup";
import PatientICDSelectComponent from "../../../../components/single_components/PatientICDSelectComponent";
import PatientSelectComponent from "../../../../components/single_components/PatientSelectComponent";
import {authenticationService} from "../../../../services/AuthenticationService";
import DatePicker from "react-datepicker";
import {CannabisPDFDenied} from "./CannabisPDFDenied";
import doctorApi from "../../../../services/ApiServices/doctorApi";
import {CannabisPDFAccepted} from "./CannabisPDFAccepted";


const validationSchema = Yup.object().shape({
    /*
        visit_summary:Yup.string().nullable().required(t('patient_boarding.field_mandatory')),
    */

})

class RequestVisitSummaryTabComposed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,
            requestStatuses: this.props.requestStatuses,
            medical_diagnose_icd: this.props.medical_diagnose_icd,
            patientTreatments: this.props.patientTreatments,
        };
    }

    getArrayLabel(givenArray, obj, otherObj) {
        let result = ""
        let {entry} = this.state
        for (let i = 0; i < givenArray.length; i++) {
            let text = givenArray[i][obj] ? givenArray[i][obj] : ""
            if (otherObj.includes("MedicalCondition")) {
                text = this.props.getConditionDesc(text, "he")
            }
            if (text === "Other" || text === "אחר") {
                text = entry[otherObj] ? entry[otherObj] : ""
            }
            if (text) {
                result = result !== "" ? result + ", " + text : text
            }
        }
        return result
    }

    async exportFile(value) {
        let {entry, patientTreatments} = this.state
        value=value.toString()
        if (value!== "5" && value !== "6") {
            return
        }
        this.props.setPatientUploading()

        entry['patientTreatments'] = patientTreatments
        let requestSummary = value === "6" ? new CannabisPDFDenied(entry) : new CannabisPDFAccepted(entry)
        let html = requestSummary.initHTML()
        html = html.replaceAll("\"", '\'')

        let fileName = value === "6" ? "CNN_BRILMEDICAL" : "CNP_BRILMEDICAL"
        fileName = fileName ? fileName + "_" + entry.ID_passport : fileName
        let currentDate = (new Date().toISOString()).split('T')
        let fileDate = currentDate ? currentDate[0] : []
        let fileTime = currentDate ? currentDate[1] : ""
        fileTime = fileTime ? fileTime.substring(0, 5) : ""

        fileName = fileName ? fileName + "_" + fileDate.split('-').join('') : fileName
        fileName = fileName ? fileName + "_" + fileTime.split(':').join('') : fileName

        let obj = {
            "html": html,
            "inline": true,
            "fileName": fileName,
            "options": {
                "displayHeaderFooter": true,
                "orientation": "Portrait",
                "pageSize": "A4",
                "footerTemplate": "<div class=\"page-footer\" style=\"width:100%; font-size:8px; color: #1d1d1b;font-family: Assistant, sans-serif; font-weight: 300;text-align:center;\"> <span class=\"pageNumber\"></span>/<span class=\"totalPages\"></span></div>"
            },
            "enableToc": false,
            "tocOptions": {
                "tocHeaderText": "Lorem Ipsum",
                "tocLevelIndentation": "1em"
            },
            "useCustomStorage": false,
            "storage": {
                "method": "PUT",
                "url": "https://presignedurl",
                "extraHTTPHeaders": {}
            }
        }
        let response = await doctorApi.generatePDFAPI(obj)

        let doc
        if (response) {
            doc = response.data.FileUrl
            let pdfSaved = await doctorApi.savePdfFile(entry.UserStorageID, entry.RequestID, {
                url: doc,
                fileName: fileName
            })
            if (pdfSaved) {
                window.open(pdfSaved.data.link, '_blank');
            }
            this.props.onValueChange("responseFile", doc)
            this.props.onValueChange("responseFileName", fileName)
        }
        this.props.setPatientUploading()
    }

    async showFile2(view) {
        let {entry, patientTreatments} = this.state
        if (view.toString() !== "5" && view.toString() !== "6") {
            return
        }
        entry['patientTreatments'] = patientTreatments

        let requestSummary = view.toString() === "6" ? new CannabisPDFDenied(entry) : new CannabisPDFAccepted(entry)

        let myWindow = window.open("", "MsgWindow", "width=1010, height=1500");
        myWindow.document.innerHTML = '';
        let checkElement = myWindow.document.getElementById("pdf-Body")
        if (checkElement) {
            myWindow.document.getElementById("pdf-Body").innerHTML = "";
        }

        let html = requestSummary.initHTML()
        html = html.replaceAll("\"", '\'')

        myWindow.document.write(html);

    }


    onChangeDiagnoseCode(value, name, code) {
        this.props.onValueChange(name, value)
        let {medical_diagnose_icd} = this.state
        let isUpdated = 0
        let otherVariable
        for (let i = 0; i < medical_diagnose_icd.length; i++) {
            let diagnose = medical_diagnose_icd[i]
            if (diagnose.ICD_diagnosis_id === 155) {
                otherVariable = {value: diagnose.ICD_diagnosis_id, label: diagnose.Diagnosis_description}
            }
            if (diagnose.Diagnosis_code === value) {
                this.props.onValueChange(code, {value: diagnose.Diagnosis_code, label: diagnose.Diagnosis_description})
                isUpdated += 1
            }
        }
        if (isUpdated === 0) {
            this.props.onValueChange(code, otherVariable)
        }
    }

    onChangeDiagnose(option, name, code, another) {
        let {medical_diagnose_icd} = this.state
        this.props.onValueChange(name, option)
        if (option.value === 155) {
            this.props.onValueChange(code, "")
        }else {
            this.props.onValueChange(another, "")
            for (let i = 0; i < medical_diagnose_icd.length; i++) {
                let diagnose = medical_diagnose_icd[i]
                if (diagnose.Diagnosis_description === option.label) {
                    this.props.onValueChange(code, diagnose.Diagnosis_code)
                }
            }
        }
    }

    handleMedicalDiagnoseChange(option) {
        this.onChangeDiagnose(option, "medical_diagnoses_icd_name", "medical_diagnoses_icd_code", "other_diagnoses")
    }


    componentWillMount() {
        this.props.initValidation(validationSchema)
    }

    async componentDidMount() {

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== this.state.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }


    onValueChange = (name, value) => {
        this.props.onValueChange(name, value)
    }
    onClickCheckboxes = (name) => {
        this.props.onClickCheckboxes(name)
    }
    onYesNoValueChange = (name, value) => {
        this.props.onYesNoValueChange(name, value)
    }


    onclickIndication(name, value) {
        this.props.onValueChange(name, value)
        if (name !== "I_other") {
            this.props.onValueChange("other_patient_type_indication", "")
        }
    }
    setValidityDate(option){
        let{entry}=this.state
        let date= new Date()
        if(option === 1){
            date = new Date(date.getFullYear(), date.getMonth()+6, date.getDate())
        }else if(option === 2){
            date = new Date(date.getFullYear()+1, date.getMonth(), date.getDate())
        }

        this.props.onValueChange("Validity_of_prescription", date)
        this.props.onValueChange("prescription_validity", option)
    }
    setValidityPrescription(event){
        this.props.onValueChange("Validity_of_prescription", event)
        this.props.onValueChange("prescription_validity", 3)
    }

    render() {

        let {t} = this.props

        let {entry, medical_diagnose_icd, requestStatuses} = this.state
        let medical_diagnose = [medical_diagnose_icd.length]
        for (let i = 0; i < medical_diagnose_icd.length; i++) {
            medical_diagnose[i] = {
                value: medical_diagnose_icd[i].ICD_diagnosis_id,
                label: medical_diagnose_icd[i].Diagnosis_description
            }
        }

        let currentUser = authenticationService.currentUserValue;
        let language = localStorage.getItem('language')

        let requestOptions = []
        for (let i = 0; i < requestStatuses.length; i++) {
            if(requestStatuses[i].status_ID.toString() ==="5" || requestStatuses[i].status_ID.toString() ==="6"|| requestStatuses[i].status_ID.toString() ==="9"){
                if (language === "he") {
                    requestOptions.push(<option
                        value={requestStatuses[i].status_ID}>{requestStatuses[i].status_desc_he}</option>)
                } else {
                    requestOptions.push(<option
                        value={requestStatuses[i].status_ID}>{requestStatuses[i].status_desc}</option>)
                }
            }
        }
        let perc_date = ""
        if (entry.Validity_of_prescription) {
            perc_date = new Date(entry.Validity_of_prescription)
        }

        return (
            <div className={'patientForm-box-container'}>
                <div className={'patientsFormBoxes-title-text'}>
                    <label
                        className={'patientsFormBoxes-title-text-label'}> {t('patient_boarding.request_summary')}</label>
                </div>
                <div className={'patientsFormBoxes'}>

                    <div className={'patientsFormRow'}>
                        <div className={'inputSlotsHalfBlock-icd'}>
                            <label className={'infoLabel'}>{t('patient_boarding.medical_diagnoses_icd_name')}</label>
                            <PatientICDSelectComponent
                                selectWidth={'700px'}
                                placeholder={t('patient_boarding.icd_choose')}
                                options={medical_diagnose}
                                value={entry.medical_diagnoses_icd_name}
                                onChange={this.handleMedicalDiagnoseChange.bind(this)}
                            />
                        </div>
                        <div className={'inputSlots'}>
                            <label className={'infoLabel'}>{t('patient_boarding.medical_diagnoses_icd_code')}</label>
                            <input className={'inputBoxStyle'} name="medical_diagnoses_icd_code"
                                   value={entry.medical_diagnoses_icd_code}
                                   onChange={(event) => this.onChangeDiagnoseCode(event.target.value, event.target.name, "medical_diagnoses_icd_name")}/>
                        </div>
                        <div className={'inputSlots'}
                             style={{display: entry.medical_diagnoses_icd_name && entry.medical_diagnoses_icd_name.value === 155 ? 'block' : 'none'}}>
                            <label className={'infoLabel'}>{t('patient_boarding.other')}</label>
                            <input className={'inputBoxStyle'} name="medical_diagnoses_icd_code"
                                   value={entry.other_diagnoses}
                                   onChange={(event) => this.props.onValueChange("other_diagnoses", event.target.value)}/>
                        </div>
                    </div>

                    <div className={'patientsFormRow'}>
                        <div className={'inputSlots'}>
                            <label className={'infoLabel'}>{t('patient_boarding.Indication')}</label>
                            <select className={'selectBox'} id="med_condition" name="med_condition"
                                    value={entry.patient_indication}
                                    onChange={(event) => this.onclickIndication("patient_indication", event.target.value)}>
                                <option disabled selected value/>
                                <option value={"BehavioralDisturbance"}>{t('patient_boarding.BehavioralDisturbance')}</option>
                                <option value={"BehavioralDisturbance2"}>{t('patient_boarding.BehavioralDisturbance2')}</option>
                                <option value={t('patient_boarding.Glaucoma')}>{t('patient_boarding.Glaucoma')}</option>
                                <option value={t('patient_boarding.Gastro_Crohns_disease')}>{t('patient_boarding.Gastro_Crohns_disease')}</option>
                                <option value={t('patient_boarding.Gastro_Enterocolitis')}>{t('patient_boarding.Gastro_Enterocolitis')}</option>
                                <option value={t('patient_boarding.Idiopathic_non_cancer')}>{t('patient_boarding.Idiopathic_non_cancer')}</option>
                                <option value={t('patient_boarding.Infectious_diseases')}>{t('patient_boarding.Infectious_diseases')}</option>
                                <option value={t('patient_boarding.Neurology_adult')}>{t('patient_boarding.Neurology_adult')}</option>
                                <option value={t('patient_boarding.Neurology_Gilles')}>{t('patient_boarding.Neurology_Gilles')}</option>
                                <option value={t('patient_boarding.Neurology_Juvenile')}>{t('patient_boarding.Neurology_Juvenile')}</option>
                                <option value={t('patient_boarding.Neurology_Parkinson')}>{t('patient_boarding.Neurology_Parkinson')}</option>
                                <option value={t('patient_boarding.Neurology_refractory')}>{t('patient_boarding.Neurology_refractory')}</option>
                                <option value={t('patient_boarding.Oncology_symptom')}>{t('patient_boarding.Oncology_symptom')}</option>
                                <option value={t('patient_boarding.Oncology_chemotherapy')}>{t('patient_boarding.Oncology_chemotherapy')}</option>
                                <option value={t('patient_boarding.Palliative_care')}>{t('patient_boarding.Palliative_care')}</option>
                                <option value={t('patient_boarding.Psychiatry_PTSD')}>{t('patient_boarding.Psychiatry_PTSD')}</option>
                                <option value={t('patient_boarding.other')}>{t('patient_boarding.other')}</option>
                            </select>
                        </div>
                    </div>
                    <div className={'patientsFormRow'}>
                        <div className={'inputSlots'}
                             style={{display: entry.patient_indication === t('patient_boarding.other') ? 'block' : 'none'}}>
                            <label className={'infoLabel'}>{t('patient_boarding.enter_indication')}</label>
                            <input type="text" name="country" className={'inputBoxStyle'}
                                   defaultValue={entry.other_patient_type_indication}
                                   onChange={(event) => this.props.onValueChange("other_patient_type_indication", event.target.value)}/>
                        </div>
                    </div>
                    <div className={'patientsFormRow'}>
                        <div className={'inputSlots'}>
                            <label className={'infoLabel'}>{t('hcpLeumitPatientRequests.status')}</label>

                            <select className={'selectBox'} id="selectFileCategory" name="selectFileCategory"
                                    value={entry.requestStatus}
                                    onChange={(event) => this.props.onValueChange("requestStatus",event.target.value)}>
                                <option/>
                                {requestOptions}
                            </select>
                        </div>
                    </div>

                    <div className={'patientsFormRow-high'}>
                        <div className={'inputSlotsDoc-full'}>
                            <label className={'infoLabel'}>{t('hcpLeumitPatientRequests.status_text')}</label>
                            <textarea className={'info-inputBoxStyle-visitSummary boxMargin'}
                                      defaultValue={entry.statusText} maxLength={"5000"}
                                      onChange={(event) => this.props.onValueChange("statusText", event.target.value)}/>
                        </div>
                    </div>
     {/*               <div className={'patientsFormRow'}>

                        <div className={'inputSlots'}>
                            <div>
                                <div className={'infoLabel'} onClick={()=>this.setValidityDate(1)}>{t('hcpLeumitPatientRequests.HalfYearValidity')}</div>
                                <div className={'infoLabel'} onClick={()=>this.setValidityDate(2)}>{t('hcpLeumitPatientRequests.OneYearValidity')}</div>
                            </div>
                            <DatePicker
                                className={'inputBoxStyle-medium'}
                                showYearDropdown={true} showMonthDropdown={true}
                                dateFormat="dd/MM/yyyy"
                                selected={perc_date}
                                minDate={new Date()}
                                onChange={(event) => this.props.onValueChange("Validity_of_prescription", event)}/>
                        </div>
                    </div>*/}

                    <div className={'patientsFormRow'}>
                        <div className={'inputSlotsFlex'}>
                            <div className={'infoLabel-error-block'}>
                                <div className={'infoLabel'}>{t('patient_boarding.prescription_validity')}:</div>
                            </div>
                            <button tabIndex={0}  className={entry.prescription_validity===1? 'inputBoxStyle-validity-left-selected' :'inputBoxStyle-validity-left'}
                                    onClick={()=>this.setValidityDate(1)}>{t('hcpLeumitPatientRequests.HalfYearValidity')}</button>
                            <button tabIndex={0}  className={entry.prescription_validity===2? 'inputBoxStyle-validity-middle-selected' :'inputBoxStyle-validity-middle'}
                                    onClick={()=>this.setValidityDate(2)}>{t('hcpLeumitPatientRequests.OneYearValidity')}</button><
                            button tabIndex={0}  className={entry.prescription_validity===3? 'inputBoxStyle-validity-right-selected' :'inputBoxStyle-validity-right'}
                                    onClick={()=>this.setValidityDate(3)}>{t('hcpLeumitPatientRequests.SpecificValidity')}</button>
                            <DatePicker
                                className={'inputBoxStyle-medium'}
                                showYearDropdown={true} showMonthDropdown={true}
                                dateFormat="dd/MM/yyyy"
                                selected={perc_date}
                                minDate={new Date()}
                                onChange={(event) => this.setValidityPrescription(event)}/>
                        </div>
                    </div>

                    {entry.renewCurrentDose ==="Yes" && <div className={'patientsFormRow'}>
                        <div className={'infoLabel'}>{t('patient_boarding.renewCurrentDose')}</div>
                    </div>}
                    <div>
                            <button className={'view-visit-summary-button'}
                                    onClick={() => this.showFile2(entry.requestStatus)}>{t('patient_boarding.view_summary_report')}</button>
                            <button className={'view-visit-summary-button'}
                                    onClick={() => this.exportFile(entry.requestStatus)}>{t('patient_boarding.view_summary_PDF')}</button>
                        </div>

                </div>
            </div>
        );
    }
}


const RequestVisitSummaryTab = compose(
    withTranslation(),
    /*connect(
        mapStateToProps,
        mapDispatchToProps
    )*/
)(RequestVisitSummaryTabComposed);

export default RequestVisitSummaryTab;

